module.exports = __webpack_public_path__ + "img/ready-tip@3x.8b3190fe.png";